import { QueryClient } from "@tanstack/react-query";

const FIVE_MINUTES = 5 * 60 * 1000;

const DEFAULT_STALE_TIME = 30 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: DEFAULT_STALE_TIME,
      gcTime: FIVE_MINUTES,
      retry: 2,
      refetchOnWindowFocus: false,
      refetchOnReconnect: "always",
      refetchOnMount: true,
    },
  },
});
